import { PageHeader, Show } from '../../components';
import { useCreateBreadCrumbs } from '../../hooks';
import { useTranslation } from 'react-i18next';
import ConciergeTab from './components/concierge';
import AffiliateTab from './components/affiliate';
import InternalStaffTab from './components/internalStaff';

const Sellers = ({ mode = 'CONCIERGE' }) => {
  const { t } = useTranslation('translation', { keyPrefix: 'screens.concierges' });
  const { t: tGeneric } = useTranslation('translation', { keyPrefix: 'components.sideBar' });

  const title =
    mode === 'CONCIERGE'
      ? t('title')
      : mode === 'INTERNAL_STAFF'
      ? tGeneric('internalStaff')
      : tGeneric('affiliates');
  useCreateBreadCrumbs([{ name: title }], mode);

  return (
    <>
      <PageHeader title={title} marginBottom={false} />
      <Show.When isTrue={mode === 'CONCIERGE'}>
        <ConciergeTab />
      </Show.When>
      <Show.When isTrue={mode === 'INDEPENDENT'}>
        <AffiliateTab />
      </Show.When>
      <Show.When isTrue={mode === 'INTERNAL_STAFF'}>
        <InternalStaffTab />
      </Show.When>
    </>
  );
};

export default Sellers;
